import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../config";

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSession = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/api-check-session.php`,
        { withCredentials: true }
      );

      if (res.data.status === "success") {
        setSession(res.data.session);
      } else {
        setSession(null);
      }
    } catch (err) {
      console.error("Session error:", err);
      setSession(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSession();

    const interval = setInterval(fetchSession, 5000); // ✅ correct 5 sec
    return () => clearInterval(interval);
  }, []);

  return (
    <SessionContext.Provider value={{ session, setSession, fetchSession, loading }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);